import { isEqual } from 'lodash';
import { TagRequest } from '@tiendanube/common';
import { getTags } from './helpers';

export const generateTagsPayload = (
  originalTags: string[],
  newTags: string | undefined,
): { tags: TagRequest[] } | undefined => {
  if (!newTags) return undefined;
  const newTagsArray = getTags(newTags);

  if (isEqual(originalTags, newTagsArray)) return undefined;

  const tagsToCreate: TagRequest[] = [];
  const tagsToDelete: TagRequest[] = [];

  originalTags.forEach((tag) => {
    if (!newTagsArray.includes(tag)) {
      tagsToDelete.push({ tag, '@delete': true });
    }
  });

  newTagsArray.forEach((tag) => {
    if (!originalTags.includes(tag)) {
      tagsToCreate.push({ tag });
    }
  });

  return { tags: [...tagsToCreate, ...tagsToDelete] };
};
